var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInGooglepayUpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 31,
    viewBox: "0 0 100 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2619_6016)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2619_6016",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 31
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 0.5H0V30.5H100V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2619_6016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.12 3.5H20C13.4 3.5 8 8.9 8 15.5C8 22.1 13.4 27.5 20 27.5H41.12C47.72 27.5 53.12 22.1 53.12 15.5C53.12 8.9 47.72 3.5 41.12 3.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.12 4.472C42.602 4.472 44.042 4.766 45.398 5.342C46.712 5.9 47.888 6.698 48.908 7.712C49.922 8.726 50.72 9.908 51.278 11.222C51.854 12.578 52.148 14.018 52.148 15.5C52.148 16.982 51.854 18.422 51.278 19.778C50.72 21.092 49.922 22.268 48.908 23.288C47.894 24.302 46.712 25.1 45.398 25.658C44.042 26.234 42.602 26.528 41.12 26.528H20C18.518 26.528 17.078 26.234 15.722 25.658C14.408 25.1 13.232 24.302 12.212 23.288C11.198 22.274 10.4 21.092 9.842 19.778C9.266 18.422 8.972 16.982 8.972 15.5C8.972 14.018 9.266 12.578 9.842 11.222C10.4 9.908 11.198 8.732 12.212 7.712C13.226 6.698 14.408 5.9 15.722 5.342C17.078 4.766 18.518 4.472 20 4.472H41.12ZM41.12 3.5H20C13.4 3.5 8 8.9 8 15.5C8 22.1 13.4 27.5 20 27.5H41.12C47.72 27.5 53.12 22.1 53.12 15.5C53.12 8.9 47.72 3.5 41.12 3.5Z",
    fill: "#3C4043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5163 16.3521V19.9821H28.3643V11.0181H31.4183C32.1923 11.0181 32.8523 11.2761 33.3923 11.7921C33.9443 12.3081 34.2203 12.9381 34.2203 13.6821C34.2203 14.4441 33.9443 15.0741 33.3923 15.5841C32.8583 16.0941 32.1983 16.3461 31.4183 16.3461H29.5163V16.3521ZM29.5163 12.1221V15.2481H31.4423C31.8983 15.2481 32.2823 15.0921 32.5823 14.7861C32.8883 14.4801 33.0443 14.1081 33.0443 13.6881C33.0443 13.2741 32.8883 12.9081 32.5823 12.6021C32.2823 12.2841 31.9043 12.1281 31.4423 12.1281H29.5163V12.1221Z",
    fill: "#3C4043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2326 13.6462C38.0846 13.6462 38.7566 13.8742 39.2486 14.3302C39.7406 14.7862 39.9866 15.4102 39.9866 16.2022V19.9822H38.8886V19.1302H38.8406C38.3666 19.8322 37.7306 20.1802 36.9386 20.1802C36.2606 20.1802 35.6966 19.9822 35.2406 19.5802C34.7846 19.1782 34.5566 18.6802 34.5566 18.0802C34.5566 17.4442 34.7966 16.9402 35.2766 16.5682C35.7566 16.1902 36.3986 16.0042 37.1966 16.0042C37.8806 16.0042 38.4446 16.1302 38.8826 16.3822V16.1182C38.8826 15.7162 38.7266 15.3802 38.4086 15.0982C38.0906 14.8162 37.7186 14.6782 37.2926 14.6782C36.6506 14.6782 36.1406 14.9482 35.7686 15.4942L34.7546 14.8582C35.3126 14.0482 36.1406 13.6462 37.2326 13.6462ZM35.7446 18.0982C35.7446 18.3982 35.8706 18.6502 36.1286 18.8482C36.3806 19.0462 36.6806 19.1482 37.0226 19.1482C37.5086 19.1482 37.9406 18.9682 38.3186 18.6082C38.6966 18.2482 38.8886 17.8282 38.8886 17.3422C38.5286 17.0602 38.0306 16.9162 37.3886 16.9162C36.9206 16.9162 36.5306 17.0302 36.2186 17.2522C35.9006 17.4862 35.7446 17.7682 35.7446 18.0982Z",
    fill: "#3C4043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2502 13.844L42.4102 22.676H41.2222L42.6502 19.586L40.1182 13.844H41.3722L43.1962 18.248H43.2202L44.9962 13.844H46.2502Z",
    fill: "#3C4043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9336 15.6199C24.9336 15.2443 24.9 14.8849 24.8376 14.5393H20.0088V16.5193L22.7898 16.5199C22.677 17.1787 22.314 17.7403 21.7578 18.1147V19.3993H23.4132C24.3798 18.5047 24.9336 17.1823 24.9336 15.6199Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.759 18.1148C21.2982 18.4256 20.7048 18.6074 20.0106 18.6074C18.6696 18.6074 17.532 17.7038 17.1246 16.4858H15.417V17.8106C16.263 19.4894 18.0018 20.6414 20.0106 20.6414C21.399 20.6414 22.5654 20.1848 23.4144 19.3988L21.759 18.1148Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9635 15.503C16.9635 15.161 17.0205 14.8304 17.1243 14.5196V13.1948H15.4167C15.0669 13.889 14.8701 14.6726 14.8701 15.503C14.8701 16.3334 15.0675 17.117 15.4167 17.8112L17.1243 16.4864C17.0205 16.1756 16.9635 15.845 16.9635 15.503Z",
    fill: "#FABB05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0106 12.398C20.7684 12.398 21.447 12.659 21.9828 13.169L23.4498 11.7032C22.5588 10.8734 21.3972 10.364 20.0106 10.364C18.0024 10.364 16.263 11.516 15.417 13.1948L17.1246 14.5196C17.532 13.3016 18.6696 12.398 20.0106 12.398Z",
    fill: "#E94235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7261 19.9923H83.0654L85.373 11.708H87.0337L84.7261 19.9923Z",
    fill: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8636 11.9674C83.7501 11.8094 83.5723 11.7305 83.3302 11.7305H74.2059L73.7557 13.355H75.4164H82.0554L81.5711 15.0886H74.9322V15.0848H73.2715L71.8945 20.0298H73.5552L74.4782 16.7131H81.9419C82.1764 16.7131 82.3958 16.6341 82.6001 16.4762C82.8044 16.3182 82.9406 16.1227 83.0049 15.8895L83.9279 12.5728C83.9998 12.3246 83.9771 12.1253 83.8636 11.9674Z",
    fill: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9256 19.4737C70.8348 19.8009 70.5322 20.0303 70.1917 20.0303H61.631C61.3965 20.0303 61.2225 19.9513 61.109 19.7934C60.9955 19.6354 60.969 19.4399 61.0371 19.2068L63.1253 11.731H64.786L62.921 18.4095H69.5638L71.4287 11.731H73.0894L70.9256 19.4737Z",
    fill: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9001 11.7231L91.9996 15.8747L87.585 20.0263L89.9001 11.7231Z",
    fill: "#098041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4254 11.7231L90.5249 15.8747L86.1064 20.0263L88.4254 11.7231Z",
    fill: "#E97626"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2619_6016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 30,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInGooglepayUpi);
export default __webpack_public_path__ + "static/media/in_googlepay_upi.3798a5d7a18f118a5ac150610ac37eaf.svg";
export { ForwardRef as ReactComponent };